import { Container } from 'components/layout/Container';
import { Template } from 'components/PurchaseContent/Template/Template';

export const RCWPage = () => (
  <>
    <Container>
      <Template />
    </Container>
  </>
);
